import { h } from '../';
import { setFetchStartState } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const caseUpdatesReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_CASE_UPDATES_START:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, setFetchStartState(state[payload.id], payload.res)) });
        case actionTypes.FETCH_CASE_UPDATES_ERROR:
        case actionTypes.FETCH_CASE_UPDATES_SUCCESS:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, payload.res) });
        case actionTypes.UPDATE_CONTINUED_EVENT: {
            if (state[payload.id] &&
                h.isLoaded(state[payload.id]) &&
                // @ts-ignore
                state[payload.id].data) {
                return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign(Object.assign({}, state[payload.id]), { 
                        // @ts-ignore
                        data: state[payload.id].data.map((u) => !payload.updateId || payload.updateId === u.updateId
                            ? Object.assign(Object.assign({}, u), { continuedAt: new Date().toISOString() }) : u) }) });
            }
            return state;
        }
        case actionTypes.NEW_UPDATE: {
            if (state[payload.kase.id] &&
                h.isLoaded(state[payload.kase.id]) &&
                // @ts-ignore
                state[payload.kase.id].data) {
                // @ts-ignore
                const update = state[payload.kase.id].data;
                return Object.assign(Object.assign({}, state), { [payload.kase.id]: Object.assign(Object.assign({}, state[payload.kase.id]), { data: [
                            ...update,
                            Object.assign(Object.assign(Object.assign({}, payload.updateType), { updateTypeGroupId: payload.updateType.groupId, updateTypeGroupLabel: payload.updateType.groupLabel }), payload.update),
                        ] }) });
            }
            return state;
        }
        default:
            return state;
    }
};
export const caseSatisfactionsReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_CASE_SATISFACTIONS_START:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, setFetchStartState(state[payload.id], payload.res)) });
        case actionTypes.FETCH_CASE_SATISFACTIONS_ERROR:
        case actionTypes.FETCH_CASE_SATISFACTIONS_SUCCESS:
            return Object.assign(Object.assign({}, state), { [payload.id]: Object.assign({}, payload.res) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map